"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Checks whether the given string is valid JSON.
 *
 * @see {@link https://gitlab.fitness-plus.net/developers/utils#isstringjsonstring}
 */
function isStringJson(string) {
    try {
        JSON.parse(string);
    }
    catch (e) {
        return false;
    }
    return true;
}
exports.default = isStringJson;
